export const fastcash = [
  "fastcash",
  "fastcashmoneyplus",
  "fastcashmoneyplusbiz",
  "fastcashmoneybiz",
  "moneybucks",
  "bucks",
  "fast",
  "cash",
  "money",
  "rich",
  "wealth",
  "saving",
  "savings",
  "crypto",
  "cryptocurrency",
  "bitcoin",
  "btc",
  "ethereum",
  "eth",
  "invest",
  "investing",
  "finance",
  "ico",
  "fortune",
  "millionaire",
  "billionaire",
  "blockchain",
  "economy",
  "payment",
  "trick",
  "profit",
]

export const woo = [
  "woo",
  "spirit",
  "spirituality",
  "god",
  "chakra",
  "chakras",
  "sound",
  "meditation",
  "reality",
  "dream",
  "dreams",
  "hypnosis",
  "mantra",
  "mantras",
  "technique",
  "energy",
  "karma",
  "cleanse",
  "vegan",
  "ascend",
  "ascension",
  "newage",
]

export const mentalHealth = [
  "sad",
  "depressed",
  "melencholy",
  "anxious",
  "anxiety",
  "depression",
  "anhedonia",
  "motivation",
  "happy",
  "mental",
  "brain",
  "suicide",
  "suicidal",
  "ocd",
  "obsessed",
  "scared",
  "fear",
  "emptiness",
  "cbd",
  "antidepressant"
]

export const politics = [
  "politics",
  "political",
  "government",
  "taxes",
  "democrats",
  "republicans",
  "gop",
  "liberal",
  "liberals",
  "conservative",
  "conservatives",
  "libtards",
  "cucks",
  "cuck",
  "trump",
  "clinton",
  "jews",
  "rockefellers",
  "jfk",
  "fascism",
  "fascist",
  "socialist",
  "socialism",
  "abortion",
  "guns",
  "shillary",
  "sjw",
  "sjws",
  "social",
  "justice",
  "warriors",
  "global",
  "china",
  "russia",
  "fakebullshit",
  "fakebullshitnews",
]

export const conspiracy = [
  "ti",
  "targeted",
  "target",
  "tracking",
  "conspiracy",
  "nuclear",
  "drone",
  "5g",
  "radiation",
  "alien",
  "aliens",
  "ufo",
  "ufos",
  "roswell",
  "brain",
  "mind-control",
  "chemtrails",
  "tracking",

]

export const general = [
  "achieve",
  "love",
  "sex",
  "greed",
  "power",
  "pizza",
  "hammers",
  "soap",
  "puppies",
  "cats",
  "friendworld",
  "friendworldsocial",
  "trains",
  "subway",
  "food",
  "candy",
  "family"

]

export const gender = {
  male: [
    'man',
    'male',
    'm',
    'boy',
    'guy',
    'b',
    'dude',
    'bro',
    'penis',
    'dick',
    'cock',
  ],
  female: [
    'woman',
    'female',
    'f',
    'girl',
    'g',
    'gal',
    'broad',
    'bitch',
    'vagina'
  ],
  other: [
    'transgender',
    'transexual',
    'trans',
    't',
    'transmasculine',
    'transfeminine',
    'intergender',
    'agender',
    'androgynous'
  ]
}

const imFuckingLazy = ["fastcash","fastcashmoneyplus","fastcashmoneyplusbiz","fastcashmoneybiz","moneybucks","bucks","fast","cash","money","rich","wealth","saving","savings","crypto","cryptocurrency","bitcoin","btc","ethereum","eth","invest","investing","finance","ico","fortune","millionaire","billionaire","blockchain","economy","payment","trick","profit","throwing","economic","explosion","market","comfort","home","house","apartment","success","food","taste","suit","dream","dreams","sleep","pillow","weird","family","vortex","hillary","clinton","politics","political","government","democrats","republicans","gop","liberal","liberals","conservative","conservatives","libtards","cucks","cuck","socialist","socialism","shillary","sjw","sjws","social","justice","warriors","science","chemicals","chemtrails","target","targeted","targeting","woo","cleanse","spirit","mental","spirituality","god","chakra","chakras","sound","meditation","reality","hypnosis","mantra","mantras","technique","energy","karma","vegan","ascend","ascension","newage","consciousness","ti","individual","tracking","conspiracy","nuclear","drone","5g","radiation","alien","aliens","ufo","ufos","roswell","brain","mind-control","sad","depressed","melencholy","anxious","anxiety","depression","anhedonia","motivation","happy","suicide","suicidal","ocd","obsessed","scared","fear","emptiness","cbd","antidepressant","addicted","addicting","addiction","internet","evacuate","planet","wrong","psychology","remember","forget","forgetting","foot","death","toenail","nail","fungus","feet","elderly","back","pain","organ","organs","accupuncture","intestine","liver","heart","male","man","testosterone","hair","loss","bald","balding","woman","female","fat","skinny","pepper","hot","furnace","drip","cancer","stop","dead","blood","cells","add","indigo","child","children","special","collective","illuminati","holocaust","internet-of-things","iot","vr","virtual","individuality","jew","jews","jewish","semetic","subliminal","astral","projection","light","healing","luck","clover","horseshoe","sexy","binaural","beats","music","sperm","seamen","sex","digital","hologram","simulation","illusion","numbers","numeric","dna","information","funny","laugh","laughing","lol","haha","kitty","kitten","cat","meow","virus","infected","pleiadians","space","physics","bunker","atlas","nuke","war","disaster","apocalypse","bomb","survival","shelter","girl","doctor","bowels","shit","poop","constipated","octopus","puzzle","stimulation","electrode","dbs","deep","therapy","scanners","scanner","tracker","beauty","ugly","surgery","plastic","constipation","constipate","poo","darpa","mind","control","pot","weed","drugs","marijuana","seduction","dating","romance","singles","chess","666","2016","freemasonry","universal","emperor","42","miracle","hell","genesis","bread","jesus","christianity","sandwich","bible","safe","safety","spyware","malware","security","towers","smartphone","weaponized","thoughts","cognitive","knowledge","processing","radio","transmission","nsa","microwave","frequency","nwo","new","world","order","state","corruption","x-ray","skull","dopamine","driving","muscle","work","hate","emf","electromagnetic","relationship","cocreate","relationships","electo","magnetic","intuition","soul","dreaming","lucid","suffering","jewelry","electric","buddha","moon","christ","blessing","buddhism","harmony","harmonics","spiritual","unarius","venus","mars","water","hydrogen","ion","acidic","alkaline","radicals","health","h20","infinity","oasis","ph","teeth","tooth","dental","dentist","implants","implant","cavity","mouth","gums","dentures","weight","quantum","motivaitonal","phobia"]

export default new Set([
  ...fastcash,
  ...woo,
  ...mentalHealth,
  ...politics,
  ...general,
  ...conspiracy,
  ...gender.male,
  ...gender.female,
  ...gender.other,
  ...imFuckingLazy,
])
